var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cards.length > 0)?_c('div',{staticClass:"card-grid"},[_c('ul',{staticClass:"card-grid__items"},_vm._l((_vm.cards),function(card,index){return _c('li',{key:index},[_c('Card',{attrs:{"post":card}})],1)}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }